import React, {useEffect, useRef, useMemo, useState} from 'react';
import PropTypes from 'prop-types';
import {Button, Space, Drawer} from 'antd';
import NewsPreview from '@/page/component/NewsFormModal/NewsPreview';
import ExtraNewsItemView from './ExtraNewsItemView';
import ExtraNewsSendDrawer from './ExtraNewsSendDrawer';

import styles from './ExtraNewsView.module.less';

ExtraNewsView.propTypes = {
    news: PropTypes.shape({
        id: PropTypes.string,
        appId: PropTypes.string,
        items: PropTypes.array,
    }).isRequired,
};

function ExtraNewsView({news}) {
    const ExtraNewsSendDrawerRef = useRef();
    const newsItems = useMemo(() => news.items || [], [news.items]);
    const [activeItemId, setActiveItemId] = useState(newsItems?.[0]?.id);
    useEffect(() => {
        setActiveItemId(newsItems?.[0]?.id);
    }, [newsItems]);

    if (newsItems.length === 1) {
        return <ExtraNewsItemView newsItem={newsItems[0]} />;
    }

    const itemIds = newsItems.map(({id}) => id);
    const itemById = newsItems.reduce((prev, current) => {
        return {
            ...prev,
            [current.id]: current,
        };
    }, {});

    // console.log(itemById);

    function onPreviewClick(id) {
        setActiveItemId(id);
    }

    function onSendClick() {
        ExtraNewsSendDrawerRef.current.show();
    }

    return (
        <div className={styles.container}>
            <div className={styles.preview}>
                <Space size="large" direction="vertical">
                    <NewsPreview
                        selectable
                        editable={false}
                        newsById={itemById}
                        tmpIds={itemIds}
                        currentTmpId={activeItemId}
                        onPreviewClick={onPreviewClick}
                    />
                    <Button type="primary" style={{width: '100%'}} onClick={onSendClick}>
                        发送多图文消息
                    </Button>
                </Space>
                <ExtraNewsSendDrawer
                    ref={ExtraNewsSendDrawerRef}
                    tmpIds={itemIds}
                    newsById={itemById}
                    currentTmpId={itemIds[0]}
                    multi
                    newsId={news.id}
                    appId={news.appId}
                />
            </div>
            <div className={styles.main}>
                <ExtraNewsItemView newsItem={itemById[activeItemId]} />
            </div>
        </div>
    );
}

export default ExtraNewsView;
